module.exports = __webpack_public_path__ + "static/media/appstore-1b.c2e2cb8e.png";